<template>
  <div>
    <modal name="webhooksEdit" height="auto" width="900" :scrollable="true" :clickToClose="false">
      <CloseModal :close="close" />
      <div class="modalbox">
        <div class="modalbox-content">
          <CTabs variant="tabs" class="nav-tabs-boxed">
            <CTab :title="item.id ? 'Editar Webhook' : 'Novo Webhook'">
              <div class="xrow">
                <div class="col-1-1">
                  <div class="form-group">
                    <label>Titulo</label>
                    <input class="form-control" v-model="item.titulo" placeholder="Ex: Notificar ERP sobre novos pedidos" />
                    <div class="message">{{ validation.firstError('item.titulo') }}</div>
                  </div>
                </div>
                <div class="col-1-1">
                  <div class="form-group">
                    <label>URL do Endpoint</label>
                    <input class="form-control" v-model="item.url" placeholder="https://exemplo.com/webhook" />
                    <div class="message">{{ validation.firstError('item.url') }}</div>
                  </div>
                </div>
                <div class="col-1-1">
                  <div class="form-group">
                    <label>Evento</label>
                    <select class="form-control" v-model="item.evento">
                      <option value="">Selecione um evento</option>
                      <option v-for="evento in eventos" :key="evento.event" :value="evento.event">
                        {{ evento.display }}
                      </option>
                    </select>
                    <div class="message">{{ validation.firstError('item.evento') }}</div>
                  </div>
                </div>
                <div class="col-1-1">
                  <div class="form-group">
                    <label>Ativo</label>
                    <select class="form-control" v-model="item.ativo">
                      <option :value="1">Sim</option>
                      <option :value="0">Nao</option>
                    </select>
                  </div>
                </div>
              </div>
            </CTab>
          </CTabs>
        </div>
      </div>
      <div class="modal-footer">
        <button :class="{ 'button button-success': true, 'button-disabled': validation.hasError() }"
                v-on:click="handleSubmit">
          Salvar
        </button>
        &nbsp;
        <button class="button" v-on:click="close">Fechar</button>
      </div>
    </modal>
  </div>
</template>

<script>
import { Validator } from "simple-vue-validator";
import CloseModal from "../../../components/CloseModal";

export default {
  name: "webhooksEdit",
  props: ["item", "update", "close", "eventos"],
  components: { CloseModal },
  validators: {
    "item.titulo": (value) => Validator.value(value).required("Titulo e obrigatorio"),
    "item.url": (value) => Validator.value(value).required("URL e obrigatoria"),
    "item.evento": (value) => Validator.value(value).required("Selecione um evento"),
  },
  methods: {
    handleSubmit() {
      this.$validate().then((success) => {
        if (success) {
          this.update();
        }
      });
    },
  },
};
</script>
